/* RESPONSIBLE TEAM: team-inbox-management */
import ApplicationAdapter from '../application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'inbox/admin_app_sidebar_sections/available_sections';
  },
});
